.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: var(--tuna-shape-borderRadius);
  cursor: pointer;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-button-fontSize);
  font-weight: var(--tuna-typography-button-fontWeight);
  line-height: var(--tuna-typography-button-lineHeight);
  letter-spacing: var(--tuna-typography-button-letterSpacing);
  text-transform: uppercase;
  padding: 6px 16px;
  min-width: 64px;
  transition:
    background-color var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut),
    box-shadow var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut),
    color var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut);
  background-color: transparent;
  color: var(--tuna-palette-primary-main);
  text-decoration: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.button:hover {
  background-color: var(--tuna-palette-action-hover);
}

.button:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.button:disabled {
  color: var(--tuna-palette-action-disabled);
  cursor: default;
  pointer-events: none;
}

.icon {
  display: inherit;
}

.contained {
  background-color: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
  box-shadow: var(--tuna-shadow-2);
}

.contained:hover {
  background-color: var(--tuna-palette-primary-dark);
  box-shadow: var(--tuna-shadow-4);
}

.contained:disabled {
  background-color: var(--tuna-palette-action-disabledBackground);
  box-shadow: none;
}

.outlined {
  border: 1px solid var(--tuna-palette-primary-main);
  padding: 5px 15px;
}

.outlined:hover {
  background-color: color-mix(in oklch, var(--tuna-palette-primary-main) 8%, transparent);
}

.outlined:disabled {
  border-color: var(--tuna-palette-action-disabled);
}

.colorSecondary {
  color: var(--tuna-palette-secondary-main);
}
.contained.colorSecondary {
  background-color: var(--tuna-palette-secondary-main);
  color: var(--tuna-palette-secondary-contrastText);
}
.contained.colorSecondary:hover {
  background-color: var(--tuna-palette-secondary-dark);
}
.outlined.colorSecondary {
  border-color: var(--tuna-palette-secondary-main);
}

.colorError {
  color: var(--tuna-palette-error-main);
}
.contained.colorError {
  background-color: var(--tuna-palette-error-main);
  color: var(--tuna-palette-error-contrastText);
}
.outlined.colorError {
  border-color: var(--tuna-palette-error-main);
}

.colorInherit {
  color: inherit;
}

.sizeSmall {
  font-size: 0.8125rem;
  padding: 4px 10px;
  min-width: 0;
}

.sizeLarge {
  font-size: 0.9375rem;
  padding: 8px 22px;
}

.fullWidth {
  width: 100%;
}
